import { useApiSend } from "@/hooks/useApi";
import { unlikeUnit } from "../api";
import { useQueryClient } from "@tanstack/react-query";

export function useUnlikeUnit({ unit }) {
	const queryClient = useQueryClient();

	const { mutateAsync, isPending, isError, error } = useApiSend({
		mutationKeys: [
			"courses",
			unit.module.course.slug,
			"modules",
			unit.module.slug,
			"units",
			unit.slug,
			"like",
		],
		invalidateKeys: [["courses", unit.module.course.slug, "units", "list"]],
		fn: async () => {
			const unitDataQueryKey = [
				"courses",
				unit.module.course.slug,
				"modules",
				unit.module.slug,
				"units",
				unit.slug,
			];

			await queryClient.cancelQueries({
				queryKey: unitDataQueryKey,
			});

			// Snapshot the previous value
			const previousUnitData = queryClient.getQueryData(unitDataQueryKey);

			// Optimistically update to the new value
			queryClient.setQueryData(unitDataQueryKey, (old) => {
				return {
					...old,
					video: {
						...old?.video,
						is_liked: false,
						like_count: old?.video?.is_liked
							? old?.video?.like_count - 1
							: old?.video?.like_count,
					},
				};
			});

			try {
				await unlikeUnit({ unit });
			} catch (e) {
				// Revert if it fails
				queryClient.setQueryData(unitDataQueryKey, previousUnitData);
				throw e;
			}
		},
	});

	return { unlike: mutateAsync, isPending, error, isError };
}
